import Vue from 'vue'
import VueI18n from 'vue-i18n'
import arja from './_akagiReport/ja/lang'
import trtc from './_tpeReport/tc/lang'
import trsc from './_tpeReport/sc/lang'
import trja from './_tpeReport/ja/lang'
import rtc from './_report/tc/lang'
import ren from './_report/en/lang'
import rja from './_report/ja/lang'
import en from './en/lang'
import ja from './ja/lang'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'tc'

const i18n = new VueI18n({
  locale,
  messages: {
    arja,
    trtc,
    trsc,
    trja,
    rtc,
    ren,
    rja,
    en,
    ja
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/constants/lang/i18n.js